
        <div class="row" [hidden]="msgHead.msg == ''">
            <div class="col-lg-8 col-md-6 col-xs-12">
                <alert [alert]="msgHead"></alert>
            </div>
        </div>
        <div *ngIf="hasAccess" class="row">
            <div class="col-lg-6 col-md-6 col-xs-12">
                <alert [alert]="msg" style="display:block;"></alert>
            </div>
        </div>
        <div *ngIf="hasAccess" class="row">
            <div class="col-lg-8 col-md-7 col-xs-12">
                <button type="button" class="btn btn-large btn-primary" (click)="addRole()">Add New</button>
				<button type="button" class="btn btn-large btn-deny" style="margin-left:5px;" (click)="refresh()">Refresh</button>
				<a style="margin-left:10px;cursor: pointer;" (click)="goBack()">Go Back</a>
				</div>
		    <div class="col-lg-8 col-md-12 col-xs-12">
                <div class="card">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Organization</th>
                                <th>Service</th>
                                <th>Roles</th>
										  <th>Updated At</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of data; let i = index">
                                <td style="width:15%;">{{ row.organizationName }}</td>
                                <td style="width:15%;">{{ row.serviceId }}</td>
										  <td style="width:12%;">
            								<span class="tag" *ngFor="let role of row.roles.split(','); let j = index" style="padding: 2px 4px; display: inline-block; margin-bottom: 3px; margin-right: 3px;">{{role}}</span>
            						  </td>
                                <td style="width:15%;">{{ printDate(row.updatedAt) }}</td>
                                <td style="width:25%;">
                                    <span title="Edit" class="btn-link" style="cursor: pointer;" (click)="edit(row)">Edit</span> |
                                    <span title="Remove Role" class="glyphicon glyphicon-trash" aria-hidden="true" (click)="removeRow(row)" style="cursor:pointer;"></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
		  </div>
    